
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Card, CardBody, Chip, Button } from "@nextui-org/react"

import { calculateTotalByKey, selectFilter } from "../../Utility/utility.js"
import { usePost } from "../../api/reactQueryCustomHooks.jsx"
import { ENUM_DASHBOARD_COLOR, apiRoute } from "../../constants/enum.js"
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../components/index.js"
import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  SELECTION_MODE,
} from "../../components/NextUITable.jsx"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFilter, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons"


const filterTableFn = ({ data, columnNames, keyColumn, conditions }) => {
  let newData = data

  if (Object.values(conditions).join("")) {
    newData = selectFilter({ data: newData, conditions })
  }

  newData = calculateTotalByKey({
    data: newData,
    columnNames,
    keyColumn,
  })

  return newData
}

function GrayProduction() {
  const { compCode, startDate, endDate } = useSelector((state) => state.company)
  const [tableFilter, setTableFilter] = useState({
    "Unit": "",
    mnth: "",
    item_desc: "",
    machine: ""
  })
  const { mnth, item_desc, machine } = tableFilter
  const {
    isPending,
    isError,
    data = [],
    mutate: filterData
  } = usePost({
    url: apiRoute.production.greyProduction,
    queryKey: "Production",

  })
  const [filterDate, setFilterDate] = useState({
    start:startDate ? new Date(startDate).toISOString().split("T")[0]:null,
    end:endDate? new Date(endDate).toISOString().split("T")[0]:null
  })
  const handleResetFilter = (() => {

    setFilterDate({
      start: new Date(startDate).toISOString().split("T")[0],
      end: new Date(endDate).toISOString().split("T")[0]
    })

    filterData({
      data: {
        compcode: compCode.join(","),
        fromdate: new Date(startDate).toISOString().split("T")[0],
        todate: new Date(endDate).toISOString().split("T")[0],
      }
    })
  })

  const funloadData = (() => {
    filterData({
      data: {
        compcode: compCode.join(","),
        fromdate: filterDate.start
          ? new Date(filterDate.start).toISOString().split("T")[0]
          : null,
        todate: filterDate.end
          ? new Date(filterDate.end).toISOString().split("T")[0]
          : null,
      }
    })
  })

  const handleFilter = () => {
    funloadData();
  }
  useEffect(() => {
  
    funloadData();
  }, [])
  const columnNames = ["taka", "meter", "pcs", "mm"]

  const [selectedFilter, setSelectedFilter] = useState([])
  const [unitWiseData, setUnitWiseData] = useState([])
  const [monthWiseData, setMonthWiseData] = useState([])
  const [productWiseData, setProductWiseData] = useState([])
  const [machineWiseData, setMachineWiseData] = useState([])




  useEffect(() => {
    const newData = filterTableFn({
      data,
      columnNames,
      keyColumn: "Unit",
      conditions: { mnth, item_desc, machine },
    })
    setUnitWiseData(newData)
  }, [data, mnth, item_desc, machine])

  useEffect(() => {
    const newData = filterTableFn({
      data,
      columnNames,
      keyColumn: "mnth",
      conditions: {
        "Unit": tableFilter["Unit"],
        item_desc,
        machine,
      },
    })
    setMonthWiseData(newData)
  }, [data, tableFilter["Unit"], item_desc, machine])


  useEffect(() => {
    const newData = filterTableFn({
      data,
      columnNames,
      keyColumn: "item_desc",
      conditions: {
        "Unit": tableFilter["Unit"],
        mnth,
        machine,
      },
    })
    setProductWiseData(newData)
  }, [data, mnth, tableFilter["Unit"], machine])

  useEffect(() => {
    const newData = filterTableFn({
      data,
      columnNames,
      keyColumn: "machine",
      conditions: {
        "Unit": tableFilter["Unit"],
        mnth,
        item_desc,
      },
    })
    setMachineWiseData(newData)
  }, [data, mnth, tableFilter["Unit"], item_desc])

  let tables = [
    {
      columns: [
        {
          uid: "Unit",
          name: "Unit",
          sortable: true,
          textcolor: ENUM_DASHBOARD_COLOR.jobWork,
        },
        {
          uid: "taka",
          name: "Taka",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
        {
          uid: "meter",
          name: "Meter",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
        {
          uid: "pcs",
          name: "Pcs",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
      ],
      INITIAL_VISIBLE_COLUMNS: [
        "Unit",
        "taka",
        "meter",
        "pcs"
      ],
      downloadFileName: "Unit",
      data: unitWiseData,
      id: "Unit",
    },
    {
      columns: [
        {
          uid: "mnth",
          name: "month",
          sortable: true,
          textcolor: ENUM_DASHBOARD_COLOR.Month,
        },
        {
          uid: "taka",
          name: "Taka",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
        {
          uid: "meter",
          name: "Meter",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
        {
          uid: "pcs",
          name: "Pcs",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
      ],
      INITIAL_VISIBLE_COLUMNS: ["mnth", "taka", "meter", "pcs"],
      downloadFileName: "Production",
      data: monthWiseData,
      id: "mnth",
    },
    {
      columns: [
        { uid: "item_desc", name: "Item / Product", sortable: true, textcolor: ENUM_DASHBOARD_COLOR.Product },
        {
          uid: "taka",
          name: "Taka",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
        {
          uid: "meter",
          name: "Meter",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
        {
          uid: "pcs",
          name: "Pcs",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
      ],
      INITIAL_VISIBLE_COLUMNS: [
        "item_desc",
        "taka",
        "meter",
        "pcs"
      ],
      downloadFileName: "Production_Data_Item_Product",
      data: productWiseData,
      id: "item_desc",
    },
    {
      columns: [
        { uid: "machine", name: "Machine", sortable: true, textcolor: ENUM_DASHBOARD_COLOR.Party },
        {
          uid: "taka",
          name: "Taka",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
        {
          uid: "meter",
          name: "Meter",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
        {
          uid: "pcs",
          name: "Pcs",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
      ],
      INITIAL_VISIBLE_COLUMNS: [
        "machine",
        "taka",
        "meter",
        "pcs"
      ],
      downloadFileName: "Machine_Wise_Data",
      data: machineWiseData,
      id: "machine",
    },
  ]

  const topActionFilter = []

  const handleSelectionChange = ({ e, column }) => {

    if (e.size > 0) {
      let val = Array.from(e)[0]
      let newSelectedFilter = { key: column, value: val }

      if (!selectedFilter.find((obj) => obj.key === column)) {
        // column does not exist
        setSelectedFilter((prev) => [...prev, newSelectedFilter])
      } else {
        // column exist, but key changed
        setSelectedFilter((prev) =>
          prev.map((obj) => (obj.key === column ? newSelectedFilter : obj))
        )
      }

      setTableFilter((prev) => ({
        ...prev,
        [column]: val,
      }))

    } else {
      setSelectedFilter((prev) => prev.filter((item) => item.key !== column))
      setTableFilter((prev) => ({
        ...prev,
        [column]: "",
      }))

    }
  }

  const handleCloseSelectedFilter = (columnToRemove) => {
    setSelectedFilter(
      selectedFilter.filter((item) => item.key !== columnToRemove)
    )
    setTableFilter((prev) => ({
      ...prev,
      [columnToRemove]: "",
    }))


    if (selectedFilter.length === 1) {
      setSelectedFilter([])
    }
  }


  function SelectedFilter() {
    return (
      <div className="flex flex-wrap gap-2 mb-2">
        {selectedFilter.map((item, index) => (
          <Chip
            key={index}
            onClose={() => handleCloseSelectedFilter(item?.key)}
            color="primary"
            variant="solid"
            size="sm"
          >
            <div className="flex gap-2 items-center p-1">
              <span className="uppercase">{item?.key.replace("_", " ")}</span>
              <span className="bg-white text-primary p-0.5 rounded-md text-xs">
                {item?.value}
              </span>
            </div>
          </Chip>
        ))}
      </div>
    )
  }

  if (isPending) {
    return <LoadingCard />
  }

  if (isError) {
    return <ErrorCard />
  }

  // const
  return (
    <div>
      <MainContainer pageName="Gray Production" info={[]} breadcrumbs={["Production"]}>
        <div className="flex w-full flex-col">
          <SelectedFilter />
          <div>
            <Card shadow="sm" radius="sm" className="mb-3 h-full">
              <CardBody className="p-2">
                <div className="flex  flex-wrap items-center gap-2 w-full ">
                  <div className="flex  items-end gap-2">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label={"Start Date"}
                        views={["day", "month", "year"]}
                        format="DD/MM/YYYY"
                        value={
                          filterDate.start
                            ? dayjs(filterDate.start)
                            : filterDate.start
                        }
                        onChange={(newValue) => {
                          setFilterDate((prev) => {
                            return { ...prev, start: dayjs(newValue).format("YYYY-MM-DD") }
                          })
                        }}
                        sx={{ width: "145px" }}
                        slotProps={{ textField: { size: "small" } }}
                      />
                      <DatePicker
                        label={"End Date"}
                        views={["day", "month", "year"]}
                        format="DD/MM/YYYY"
                        value={
                          filterDate.end ? dayjs(filterDate.end) : filterDate.end
                        }
                        onChange={(newValue) => {
                          setFilterDate((prev) => {
                            return { ...prev, end: dayjs(newValue).format("YYYY-MM-DD") }
                          })
                        }}
                        slotProps={{ textField: { size: "small" } }}
                        sx={{ width: "145px" }}
                      />
                    </LocalizationProvider>
                  </div>
                  <Button
                    color="primary"
                    startContent={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                    onPress={handleFilter}
                  // isLoading={isPending}
                  >
                    Search
                  </Button>
                  <Button
                    style={{ marginLeft: "5px" }}
                    color="primary"
                    startContent={<FontAwesomeIcon icon={faFilter} />}
                    onPress={handleResetFilter}
                  >
                    Reset
                  </Button>
                </div>
              </CardBody>

            </Card>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 ">

            {/* selected filter chip */}
            {/* table */}

            {tables.map((table, index) => {
              return (
                <Card key={index}>
                  <CardBody>
                    <NextUITable
                      INITIAL_VISIBLE_COLUMNS={table.INITIAL_VISIBLE_COLUMNS}
                      data={table.data}
                      columns={table.columns}
                      downloadFileName={table.downloadFileName}
                      id={table.id}
                      rowSelection={true}
                      selectionMode={SELECTION_MODE.single}
                      showTopContent={false}
                      showFooter={false}
                      showPagination={false}
                      topActionFilter={topActionFilter}
                      handleSelectionChange={handleSelectionChange}
                    />
                  </CardBody>
                </Card>
              )
            })}
            {/* end of table */}
          </div>
        </div>
      </MainContainer>
    </div>
  )
}
export default GrayProduction
